import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

// styles
import style from '../../Styles/Containers/Modal_Alert.module.css'

// component
import Header from '../Header/header'

class ModalAlertComponent extends Component {
    constructor() {
        super();
    }
    render() {
        return (
            this.props.visible ? <div className={style.mask}>
                <div className={style.modal_large}>
                    <div className={style.large_top_content}>
                        <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-win.svg"}></img>
                        <span className={style.modal_large_top_font}>이벤트 결과!</span>
                    </div>
                    <div>{this.props.middleContent}</div>
                    
                    <div className={style.large_bottom_content}>이벤트 당첨내역에 대한 프로모션 바코드는<br></br>인증내역에서 확인할 수 있습니다</div>

                    <div className={style.large_confirm}>
                        <span 
                            className={style.confirm_font} 
                            onClick={this.props.onConfirm && this.props.onConfirm.bind(this)}>
                                {this.props.confirmFont || "확인"}
                        </span>
                    </div>
                </div>
            </div>
            :
            null
        )
    }
}

export default connect()(withRouter(ModalAlertComponent))